export default __webpack_public_path__ + "static/media/icon-mitigation-grey.dc7f5a5c.svg";